import React from "react";
import "./Contact.scss";
import emailIcon from "../../assets/icons/email.svg";
import emailIconWhite from "../../assets/icons/email-white.svg";

export default function Contact() {
  return (
    <div className="contact" id="contact">
      <div className="contact__container"></div>
      <div className="contact__overlay">
        <h2 className="contact__header">Contact Me!</h2>
        <a href="mailto:lyjchan@gmail.com">
          <div className="contact__icon"></div>
        </a>
        <p className="contact__paragraph">
          Feel free to contact me if you have any ideas for a project that needs
          someone to work on! Simply click on the email icon will open an email
          app to my email address!
        </p>
      </div>
    </div>
  );
}
